import parse from "html-react-parser";

import { PageDirectoryEntryName } from "../api/PageDirectory";
import APContactHelpButton from "../components/buttons/APContactHelpButton";
import AIButton from "../components/buttons/APOutlineButtons/AIButton";
import InfoOutlineButton from "../components/buttons/APOutlineButtons/InfoOutlineButton";
import HomeButton from "../components/buttons/HomeButton";
import RequestQuoteButton from "../components/buttons/RequestQuoteButton";
import { QuoteFormatted } from "../types/Quote";
import { coerceValue } from "./string";

export const classComponentSubstitutions = [
  "sub-vehicle-search",
  "sub-vehicle-suggestions",
  "sub-contact-help",
  "sub-request-quote",
  "sub-home",
];

export type ParseHtmlConfig = {
  quote?: QuoteFormatted;
  onNavigate: (path: string) => void;
  getScopedPageUrl: (
    entry: PageDirectoryEntryName,
    entityId?: string,
    secondaryId?: string
  ) => string;
};

export const extractDataAttributes = (attribs: Record<string, string>) => {
  return Object.entries(attribs)
    .filter(([key]) => key.startsWith("data-"))
    .reduce((acc, [key, value]) => {
      const propName = key
        .replace("data-", "")
        .replace(/-([a-z])/g, (_, char) => char.toUpperCase()); // kebab → camelCase

      acc[propName] = coerceValue(value);
      return acc;
    }, {} as Record<string, boolean | string | number>);
};

export const parseHtmlWithClassComponentSubstitutions = (
  html: string,
  config: ParseHtmlConfig
) => {
  return parse(html, {
    replace: (domNode) => {
      if (
        domNode.type === "tag" &&
        "attribs" in domNode &&
        classComponentSubstitutions.includes(
          domNode.attribs?.["data-component"]
        )
      ) {
        const props = extractDataAttributes(domNode.attribs);
        const component = domNode.attribs?.["data-component"];

        switch (component) {
          case "sub-vehicle-search":
            return (
              <InfoOutlineButton
                text="Vehicle Search"
                onClick={() => {
                  if (config?.quote) {
                    config.onNavigate(
                      config.getScopedPageUrl(
                        "dossierVehicleSearch",
                        config?.quote?.dossierId
                      )
                    );
                  }
                }}
                iconOverride="car"
              />
            );
          case "sub-vehicle-suggestions":
            return (
              <AIButton
                type="vehicle-suggestions"
                onClick={() => {
                  if (config?.quote) {
                    config.onNavigate(
                      config.getScopedPageUrl(
                        "viewQuoteVehicleSuggestions",
                        config.quote?.id
                      )
                    );
                  }
                }}
                shouldPromptForAIConsent={false}
              />
            );
          case "sub-contact-help":
            return (
              <APContactHelpButton
                {...props}
                quoteId={config?.quote?.id}
                regardingOpportunityId={config?.quote?.opportunityId}
              />
            );
          case "sub-request-quote":
            return config?.quote?.id && config?.quote?.opportunityId ? (
              <RequestQuoteButton
                quoteId={config?.quote?.id}
                opportunityId={config?.quote?.opportunityId}
                backOnRequested={true}
              />
            ) : (
              <></>
            );
          case "sub-home":
            return <HomeButton destination="dossiersHome" />;
        }
      }
    },
  });
};
